
import WebFont from 'webfontloader'

const options = {"google":{"families":["Nunito:normal,bold,italic,extrabold,semibold","Nunito Sans:normal,bold,italic,extrabold,semibold"]}}

WebFont.load(options)
